<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M16 8a4.667 4.667 0 11-9.333 0A4.667 4.667 0 0116 8zm-2 0a2.667 2.667 0 11-5.333 0A2.667 2.667 0 0114 8z" clip-rule="evenodd"/><path d="M4.667 19.334a2.667 2.667 0 012.667-2.667h8c1.103 0 2.05.67 2.455 1.625a8.046 8.046 0 011.505-1.428 4.663 4.663 0 00-3.96-2.197h-8a4.667 4.667 0 00-4.667 4.667v5.667a1 1 0 001 1h12.789a7.962 7.962 0 01-.428-2H4.667v-4.667zM24 18a1 1 0 00-1 1v3.334h-3.333a1 1 0 100 2H23v3.333a1 1 0 102 0v-3.333h3.334a1 1 0 000-2H25v-3.333a1 1 0 00-1-1z"/></svg>
</template>

<script>
export default {
  name: 'userPersonAddOutline'
}
</script>
